import { Component, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import * as icons from 'ionicons/icons';
import { addIcons } from 'ionicons';

/**
 * @description Root Ionic shell that registers the Ionicons set and hosts routed pages.
 */
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  constructor() {}

  /**
   * @description Registers every bundled Ionicon before Ionic components render icon names.
   */
  async ngOnInit() {
    for (const iconName in icons) {
      addIcons({ [iconName]: (icons as any)[iconName] });
    }
  }
}
